/** Rental request form: shows and requires the address only when delivery is chosen. The form works without this file. */

function initRentalForm(form) {
  const address = form.querySelector('[data-address]');
  const delivery = form.querySelector('[data-delivery-choice]');
  if (!address || !delivery) return;
  const radios = form.querySelectorAll('input[name="contact[Delivery or pickup]"]');
  const required = address.querySelectorAll('[data-address-field]');

  function update() {
    const anyChecked = Array.from(radios).some((radio) => radio.checked);
    const isDelivery = delivery.checked;
    address.hidden = anyChecked && !isDelivery;
    required.forEach((field) => {
      field.required = isDelivery;
    });
  }

  radios.forEach((radio) => radio.addEventListener('change', update));
  update();
}

document.querySelectorAll('[data-rental-form]').forEach(initRentalForm);

const notice = document.querySelector('[data-form-notice]');
if (notice) {
  notice.scrollIntoView({ block: 'center' });
  notice.focus({ preventScroll: true });
}

/** Event mode: ticking an item fills a quantity of 1, typing a quantity ticks the item, and at least one item is required. Items left blank are not sent. */
function initItemPicker(form) {
  const picker = form.querySelector('[data-item-picker]');
  if (!picker) return;
  const items = picker.querySelectorAll('[data-item]');
  const error = picker.querySelector('[data-item-error]');

  items.forEach((item) => {
    const check = item.querySelector('[data-item-check]');
    const qty = item.querySelector('[data-item-qty]');
    check.addEventListener('change', () => {
      if (check.checked && !qty.value) qty.value = 1;
      if (!check.checked) qty.value = '';
      if (check.checked && error) error.hidden = true;
    });
    qty.addEventListener('input', () => {
      check.checked = Number(qty.value) > 0;
      if (check.checked && error) error.hidden = true;
    });
  });

  form.addEventListener('submit', (event) => {
    const chosen = Array.from(items).filter((item) => Number(item.querySelector('[data-item-qty]').value) > 0);
    if (!chosen.length) {
      event.preventDefault();
      if (error) {
        error.hidden = false;
        error.scrollIntoView({ block: 'center' });
      }
      return;
    }
    items.forEach((item) => {
      const qty = item.querySelector('[data-item-qty]');
      if (!(Number(qty.value) > 0)) qty.disabled = true;
    });
  });
}

document.querySelectorAll('[data-rental-form]').forEach(initItemPicker);

/** Event mode: delivery and pickup must be weekdays, and pickup must come after delivery. Messages come from data attributes. */
function initWeekdayDates(form) {
  const wrap = form.querySelector('[data-weekday-dates]');
  if (!wrap) return;
  const delivery = wrap.querySelector('[data-delivery-date]');
  const pickup = wrap.querySelector('[data-pickup-date]');
  const weekdayMsg = wrap.dataset.weekdayError;
  const orderMsg = wrap.dataset.pickupError;

  function isWeekday(value) {
    if (!value) return true;
    const day = new Date(value + 'T12:00:00').getDay();
    return day >= 1 && day <= 5;
  }

  function check() {
    delivery.setCustomValidity(isWeekday(delivery.value) ? '' : weekdayMsg);
    let msg = isWeekday(pickup.value) ? '' : weekdayMsg;
    if (!msg && delivery.value && pickup.value && pickup.value <= delivery.value) msg = orderMsg;
    pickup.setCustomValidity(msg);
    if (delivery.value) pickup.min = delivery.value;
  }

  [delivery, pickup].forEach((input) => input.addEventListener('change', check));
  check();
}

document.querySelectorAll('[data-rental-form]').forEach(initWeekdayDates);
